module.exports = __webpack_public_path__ + "website/img/core12_1.333b3325.png";